import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { BieWaterfallRow } from './types';
import { formatMoney } from './format';

type Props = {
  rows: BieWaterfallRow[];
};

const WaterfallPanel: React.FC<Props> = ({ rows }) => {
  const max = Math.max(...rows.map((r) => Math.abs(Number(r.amount || 0))), 1);

  return (
    <Paper elevation={1} sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Waterfall Analysis</Typography>
      <Stack spacing={1.2}>
        {rows.map((row) => {
          const amount = Number(row.amount || 0);
          const width = Math.max(8, Math.min(100, (Math.abs(amount) / max) * 100));
          return (
            <Box key={`${row.sortorder}-${row.label}`}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ width: 210 }} variant="body2">{row.label}</Typography>
                <Box sx={{ flex: 1, height: 22, borderRadius: 1, bgcolor: 'action.hover', overflow: 'hidden' }}>
                  <Box
                    sx={{
                      width: `${width}%`,
                      height: '100%',
                      ml: amount < 0 ? 'auto' : 0,
                      bgcolor: amount < 0 ? 'error.light' : 'success.light',
                    }}
                  />
                </Box>
                <Typography sx={{ width: 120 }} align="right" variant="body2">
                  {formatMoney(amount)}
                </Typography>
              </Stack>
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
};

export default WaterfallPanel;
